import { Svg } from '@manomano-internal/tamagoshi-icons/esm/SvgOptimizer/Svg';

import { makeTamagoshiIcon } from '@/core/tamagoshiTailwind/util/makeTamagoshiComponent';

export const ArrowRightIcon = makeTamagoshiIcon((props, ref) => (
  <Svg
    fill="none"
    height="24"
    optimizationId="tama-arrow-right"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    ref={ref}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.4175 11H16.5875L11.7075 6.11997C11.3175 5.72997 11.3175 5.08997 11.7075 4.69997C12.0975 4.30997 12.7275 4.30997 13.1175 4.69997L19.7075 11.29C20.0975 11.68 20.0975 12.31 19.7075 12.7L13.1175 19.29C12.7275 19.68 12.0975 19.68 11.7075 19.29C11.3175 18.9 11.3175 18.27 11.7075 17.88L16.5875 13H5.4175C4.8675 13 4.4175 12.55 4.4175 12C4.4175 11.45 4.8675 11 5.4175 11Z"
      fill="currentColor"
    />
  </Svg>
));

ArrowRightIcon.displayName = 'ArrowRightIcon';
